<template>
  <div class="metrics-wrapper">
    <Card :header="metrics">
      <template #card-body>
        <div class="metrics-Container">
          <div
            v-for="data in InfoStatData"
            :key="data.key"
            class="stats-container"
          >
            <InfoStats
              :className="data.className"
              :textLabel="data.textLabel"
              :textValColor="data.textValColor"
              :textValue="data.textValue"
            />
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/rex-components/rex-card.vue';
import InfoStats from '@/rex-components/rex-info-stats.vue';
import * as types from '@/store/modules/k8/k8-types';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  components: { Card, InfoStats },
  name: 'InfoCardBuilder',
  data() {
    return {
      metrics: this.$t('metrics'),
      response: [
        {
          name: '',
          value: '',
        },
      ],
    };
  },
  props: {
    InfoStatData: {
      type: Array,
      default: () => [],
    },
    scope: {
      type: String,
      default: '',
    },
    isCloudMon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('globalState/app', ['updateDashboard']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('cloudState/services', ['currentGKECluster']),
  },
  methods: {
    ...mapActions('k8State/k8CommonState', {
      getK8ClusterCardsAction: 'getK8CardsData',
    }),
    async loadData() {
      let metNames = this.getMetricbyNameOfCards();
      const params = {
        request: {
          metricNames: metNames,
          entity: {
            normal: true,
            scope: this.scope,
          },
        },
        duration: this.getDurationTime,
        valueColumn: this.isCloudMon ? 'summation' : 'value',
      };
      try {
        this.response = await this.getK8ClusterCardsAction(params);
        this.populateInfoCardData();
      } finally {
        this.loadingApp = false;
      }
    },
    getMetricbyNameOfCards() {
      let metricNames = [];
      for (let i = 0; i < this.InfoStatData?.length; ++i) {
        metricNames.push(this.InfoStatData[i].metricName);
      }
      return metricNames;
    },
    getMetricbyName(metricName) {
      for (let i = 0; i < this.response?.length; ++i) {
        if (this.response[i].name === metricName) return this.response[i].value;
      }
    },
    populateInfoCardData() {
      for (let i = 0; i < this.InfoStatData?.length; ++i) {
        let value = this.getMetricbyName(
          this.InfoStatData[i].metricName,
        )?.toString();
        if (this.InfoStatData[i].transform) {
          try {
            // this is used to transform to different units by using /, *, +, - operators in `transform` field
            value = this.InfoStatData[i].transform(value);
            value = Number.parseFloat(value).toFixed(1);
          } catch (error) {
            console.error('transformation evaluation error', error);
          }
        }
        if (this.InfoStatData[i].unit) {
          value = `${value} ${this.InfoStatData[i].unit}`;
        }
        this.InfoStatData[i].textValue = value;
      }
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    getDurationTime: function (newValue, oldValue) {
      this.loadData();
    },
    updateDashboard(oldValue, newValue) {
      this.loadData();
    },
    currentGKECluster() {
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-Container {
  margin: -0.4rem;
  display: grid;
  grid-template-columns: 16.6% 16.6% 16.6% 16.6% 16.6% 16.6%;
}
.stats-container {
  display: flex;
}
.info-cards {
  margin: 0.397rem;
  border-radius: 0.75rem;
  padding-left: 3.188rem;
  padding-bottom: 2rem;
  padding-top: 1.5rem;
}
.metrics-wrapper {
  display: flex;
  width: 96.4%;
  flex-flow: row wrap;
  margin-top: 1.23rem;
  align-items: center;
}
</style>
